import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import { AlertsService } from 'src/app/alerts.service';
import { AuthService } from 'src/app/auth.service';
import { TokenStorageService } from 'src/app/token-storage.service';

@Component({
  selector: 'app-verify_otp_password',
  templateUrl: './verify_otp_password.component.html',
  styleUrls: ['./verify_otp_password.component.scss']
})
export class VerifyOtpPasswordComponent implements OnInit {
  verifyForm: FormGroup;
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  public countdownMinutes!: number;
  public countdownSeconds!: number;
  public countdownInterval!: any;
  public minutes!: string;
  public seconds!: string;
  roles: string[] = [];

  constructor(private formBuilder: FormBuilder, private router: Router, private alertService: AlertsService, private authService: AuthService, private tokenStorage: TokenStorageService) {
    this.minutes = '10';
    this.seconds = '00';
    this.countdownMinutes = 10;
    this.countdownSeconds = 0;
  }

  ngOnInit(): void {
    this.verifyForm = this.formBuilder.group({
      otp: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]]
    })
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().roles;
      this.router.navigate(['']);
    }
    this.countdownInterval = setInterval(() => {
      if (this.countdownMinutes >= 1) {
        if (this.countdownSeconds >= 1) {
          this.countdownSeconds--;
          this.seconds = String(this.countdownSeconds).padStart(2, '0');
        } else {
          this.countdownMinutes--;
          this.countdownSeconds = 59;

          this.minutes = String(this.countdownMinutes).padStart(2, '0');
          this.seconds = String(this.countdownSeconds).padStart(2, '0');
        }
      } else if (this.countdownSeconds >= 1) {
        this.countdownSeconds--;

        this.seconds = String(this.countdownSeconds).padStart(2, '0');
      } else {
        clearInterval(this.countdownInterval);
        this.router.navigate(['forgot-password']);
      }
    }, 1000)
  }

  public getUserEmail() {
    return this.authService.verificationforgotPasswordEmail;
  }

  onSubmit() {
    try {
      let toPost = {
        'email': this.authService.verificationforgotPasswordEmail,
        'otp': this.verifyForm.value.otp,
        'password': this.verifyForm.value.password,
        'confirmPassword': this.verifyForm.value.confirmPassword
      };

      this.authService.verifyFPOTP(toPost)
        .pipe(
          catchError((err: HttpErrorResponse) => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.alertService.error('Please check the OTP and try again.', "Couldn't verify OTP");
            return of(null);
          })
        )
        .subscribe(async (response) => {
          if (response) {
            await this.router.navigate(['login']);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.alertService.success('You have been verified successfully. You can now login using your new credentials', 'OTP Verified Successfully!');
          }
        });
    } catch (err) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.alertService.error(null, null);
      console.log(err);
    }
  }

  ngOnDestroy(): void {
    this.authService.verificationforgotPasswordEmail = null;
    this.authService.isOTPSent = false;
    window.onbeforeunload = null;
  }
}
